module.exports = __webpack_public_path__ + "img/air-china.28b3a4a2.webp";